export enum HublerAvailabilityReason {
  LastResort = 'LastResort',
  CounterOvertime = 'CounterOvertime',
  CounterCheckFailed = 'CounterCheckFailed',
  UnavailableSlot = 'UnavailableSlot',
  SlotCheckFailed = 'SlotCheckFailed',
}
